module.exports = __webpack_public_path__ + "img/contacts.356a9149.png";